import { MenuItem } from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { DefaultModelField } from '../../../../models/default-model';
import { useGetPartnersForFilters } from '../../../../utils/hooks/useGetPartnersForFilters';
import { GtSelect } from '../../../gt-select/GtSelect';

const EMPTY_VALUE = '-';

interface UserFilterProps {
  className: string;
  filtersValue: string;
  onFiltersChange?: (user: string) => void;
}

export function PartnerFilter({
  filtersValue,
  className,
  onFiltersChange,
}: UserFilterProps) {
  const [{ data, loading: partnersLoading }, getPartnersForFilters] =
    useGetPartnersForFilters();

  useEffect(() => {
    getPartnersForFilters({});
  }, []);

  const options = useMemo(() => {
    if (!data) {
      return [];
    }

    return [
      {
        [DefaultModelField.Id]: EMPTY_VALUE,
        name: 'All partners',
      },
      ...data,
    ];
  }, [data]);

  const onPartnerFilterChanged = (event) => {
    const { value } = event.target;

    onFiltersChange(value === EMPTY_VALUE ? undefined : value);
  };

  return (
    <GtSelect
      fullWidth
      className={className}
      variant="outlined"
      size="small"
      disabled={false}
      value={filtersValue || EMPTY_VALUE}
      onChange={onPartnerFilterChanged}
      name="partnerIds"
      label={partnersLoading ? 'Loading partners ...' : 'Filter by partners'}
      inputProps={{
        name: 'partnerFilter',
        id: 'partnerFilter',
      }}
    >
      {(options || []).map(({ id, name }) => (
        <MenuItem key={id} value={id}>
          {name}
        </MenuItem>
      ))}
    </GtSelect>
  );
}
